import React, { useContext } from 'react'
import { useTranslation } from "react-i18next";
import { Modal, Box } from "@mui/material";
import Delete from "../../icons/delete.svg";
import Editar from "../../icons/editar.svg";
import { formatoFechasEs } from '../../functions/funciones';
import { UsuarioContext } from '../../providers/userContext';
import ComentariosEstructura from '../comentariosEstructura';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '85ch',
    maxHeight: '500px',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    padding: '20px',
    overflow: 'auto',

};

const modal = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const AllObservations = (props) => {
    const { t } = useTranslation('common');
    const user = useContext(UsuarioContext)

    const eliminar = (id) => {
        props.eliminarComment(id)
        props.handleClose()
    }
    const editar = (id, comentario) => {
        props.editarComment(id, comentario)
        props.handleClose()
    }

    const fijar = (id, fijado) => {
        props.fijarComment(id, fijado)
    }

    return (
        <>
            <Modal
                open={props.opened}
                onClose={props.handleClose}
                className={modal}
            >
                <Box sx={style}>
                    {props?.observations?.length === 0 ?
                        <p>{t('observations.noObservations')}</p>
                        :
                        <>
                            <div class="comment-header">
                                <h3>{t('observations.technicianObservations')}</h3>
                            </div>
                            {props?.observations?.map((comentario,index) => {
                                return (
                                    <ComentariosEstructura 
                                        key={index}
                                        comm={comentario} 
                                        eliminarComment={eliminar}
                                        editarComment={editar}
                                        fijarComment={fijar}
                                    />
                                    // <div key={comm.id} style={{ display: 'flex', alignItems: 'center' }}>
                                    //     <span style={{ width: '40px', margin: '3px 0' }}>
                                    //         {comm.user_id === user.user_id ?
                                    //             <>
                                    //                 <img
                                    //                     src={Delete}
                                    //                     alt="ELIMINAR"
                                    //                     className="tableIcon"
                                    //                     onClick={() => eliminar(comm.id)}
                                    //                     style={{ width: 14, margin: 0 }}
                                    //                 ></img>
                                    //                 <img
                                    //                     src={Editar}
                                    //                     alt="Editar"
                                    //                     className="tableIcon"
                                    //                     onClick={() => editar(comm.id, comm)}
                                    //                     style={{ width: 14, margin: '0 0 0 3px' }}
                                    //                 ></img>
                                    //                 { }
                                    //             </>
                                    //             : null}
                                    //     </span>
                                    //     <span>
                                    //         {formatoFechasEs(comm.createdAt)} - {comm.usuario?.nombre + " " + comm.usuario?.apellidos} - {comm.texto}
                                    //     </span>
                                    // </div>
                                )
                            })}
                        </>}
                </Box>
            </Modal>
        </>
    );
}

export default AllObservations;